import { action } from 'sky-engine/api/index'

import { SERVER_MNG } from '@/api/apiModules'
/**
 * 获取外设信息
 * @param {*} data
 * @returns
 */
export function getServerList(data) {
  const params = {
    exactMatchArr: [],
    matchArr: [],
    page: 0,
    limit: 1000
  }
  return action(SERVER_MNG, 'list', data ? data : params)
}

/**
 * 获取服务器详情
 * @param {*} data
 * @returns
 */
export function getServerDetail(data) {
  return action(SERVER_MNG, 'detail', data)
}
